import { SearchItem } from '@yiluhub/yilu-amp-types';
import { useMemo } from 'react';

import { sendGAEvent } from 'utils/tracking';

import { getEurailProductDetails } from 'modules/eurail/utils/getProductDetails';

const useProductSummaryProps = (
  eurailProduct: SearchItem | undefined | null,
  reservationFormRef: React.RefObject<HTMLFormElement>,
  isReservationUpdateLoading: boolean,
) => {
  const productDetails = getEurailProductDetails(eurailProduct);

  const productSummaryProps = useMemo(() => {
    if (!eurailProduct) {
      return null;
    }

    return {
      price: productDetails.price,
      currency: productDetails.currency,
      onClick() {
        if (reservationFormRef?.current) {
          const reservationForm = reservationFormRef.current;
          reservationForm.dispatchEvent(
            new Event('submit', {
              cancelable: true,
              bubbles: true,
            }),
          );

          sendGAEvent({
            event: 'tip_cta_clicked',
            category: 'eurail-tip',
            label: 'eurail_tip_cta_clicked',
          });
        }
      },
      isLoading: isReservationUpdateLoading,
      pass: productDetails.pass,
      numberOfTravelDays: productDetails.numberOfTravelDays,
      validityPeriodMonth: productDetails.validityPeriodMonth,
      adult: productDetails.numberOfAdults,
      youth: productDetails.numberOfYouths,
      child: productDetails.numberOfChildren,
      senior: productDetails.numberOfSeniors,
      fareClass: productDetails.fareClass,
      country: productDetails.to,
    };
  }, [eurailProduct, reservationFormRef, isReservationUpdateLoading, productDetails]);

  return productSummaryProps;
};

export default useProductSummaryProps;
